import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { DEFAULT_PAGE_SIZE } from 'constants/catalog';
import { PagedResult } from 'types/api';
import { Facet, ProductListResult } from 'types/product';
import { asProductList, mapStoreProduct, StoreProductApiItem } from 'utils/mapStoreProduct';

type SearchApi = PagedResult<StoreProductApiItem> & {
  facets?: Facet[];
  appliedFilters?: Record<string, string[]>;
};

const searchService = {
  search: async (
    q: string,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE,
    facets?: Record<string, string[]>
  ): Promise<ProductListResult> => {
    const params: Record<string, string | number> = { q, pageNumber, pageSize };
    Object.entries(facets ?? {}).forEach(([key, values]) => {
      if (values?.length) params[`f.${key}`] = values.join('|');
    });
    const response = await api.get<SearchApi>(ENDPOINTS.SEARCH, { params });
    const data = response.data;
    return {
      items: asProductList(data).map(mapStoreProduct),
      totalCount: data.totalCount ?? 0,
      pageNumber: data.pageNumber ?? 1,
      pageSize: data.pageSize ?? DEFAULT_PAGE_SIZE,
      totalPages: data.totalPages ?? 0,
      facets: data.facets ?? [],
      appliedFilters: data.appliedFilters ?? {},
    };
  },
};

export default searchService;
